import { useAppStore } from '@store'
import GetOffsetDimentions from './getOffsetDimentions'

export default function DimentionsHandler({ id }: { id: string }) {
  const width = useAppStore.use.items().get(id)?.width
  return <group key={`dimentions-handler-wall:${id}-${width}`}>{GetOffsetDimentions(id)}</group>
}
